module.exports = __webpack_public_path__ + "img/png.7a2b404b.svg";